import React from "react";
import {
  Datagrid,
  DateField,
  List,
  TextField,
  TextInput,
  SelectInput,
  Filter,
  ReferenceField,
  SimpleShowLayout,
  BooleanInput,
  NumberInput,
  NumberField,
  BooleanField,
  ArrayField,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import {ConversationStatusFilter, MarketsFilter} from "../../constants/choices";
import { InvoiceFilterGateway, InvoiceFilterStatus, InvoiceFilterTypes } from "./invoiceConstants";

const InvoiceFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId" />
    <TextInput label="شماره تلفن" source="phoneNumber" />
    <NumberInput label="ایمیل" source="email" />
    <TextInput label="قیمت" source="price" />
    <TextInput label="شناسه کاربر" source="userId" />
    <BooleanInput label="کامل شده؟" source="completed" />
    <TextInput label="sku" source="sku" />
    <SelectInput label="نوع" choices={InvoiceFilterTypes} optionText={"name"} optionValue={"value"} source={"type"} alwaysOn />
    <SelectInput label="درگاه" choices={InvoiceFilterGateway} optionText={"name"} optionValue={"value"} source={"gateway"} alwaysOn />
    <SelectInput label="وضعیت" choices={InvoiceFilterStatus} optionText={"name"} optionValue={"value"} source={"status"} alwaysOn />
      <SelectInput label="مارکت" choices={MarketsFilter} optionText={"name"} optionValue={"value"} source={"market"} alwaysOn />
      <SelectInput label="وضعیت مکالمه" choices={ConversationStatusFilter} optionText={"name"} optionValue={"value"} source={"conversationStatus"} alwaysOn />
  </Filter>
);

export const InvoiceList = (props) => (
  <List {...props} filters={<InvoiceFilter />}>
    <Datagrid rowClick={"show"}>
      <TextField source="objectId" />
      <ReferenceField link="show" label="کاربر" source="userId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="price" />
      <TextField source="title" />
      <TextField source="sku" />
      <TextField source="statusName" />
      <TextField source="typeName" />
      <TextField source="market" />
      <TextField source="conversationStatusName" label="وضعیت مکالمه" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
    </Datagrid>
  </List>
);

export const InvoiceShow = (props) => (
  <ShowView {...props} noDel={true}>
    <SimpleShowLayout>
      <TextField source="objectId" />
      <ReferenceField link="show" label="کاربر" source="userId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="phoneNumber" />
      <TextField source="email" />
      <NumberField source="price" />
      <TextField source="sku" />
      <TextField source="title" />
      <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation">
        <TextField source="title" />
      </ReferenceField>
      <BooleanField source="refundedToWallet" />
      <BooleanField source="refundedToCash" />
      <TextField source="gatewayName" />
      <TextField source="statusName" />
      <TextField source="typeName" />
      <TextField source="market" />
      <TextField source="firstUserMessageDate" />
      <TextField source="conversationClosedDate" />
      <TextField source="conversationStatusName" label="وضعیت مکالمه" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
      <ArrayField source="lastTenMessages">
        <Datagrid>
          <ReferenceField link="show" label="کاربر" source="senderUserId" reference="user">
            <TextField source="name" />
          </ReferenceField>
            <TextField source="text" />
            <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
        </Datagrid>
      </ArrayField>
      <ArrayField source="gatewayDataName">
        <Datagrid>
          <TextField source="Token" />
          <TextField source="MID" />
          <TextField source="TerminalId" />
          <TextField source="RefNum" />
          <TextField source="ResNum" />
          <TextField source="State" />
          <TextField source="TraceNo" />
          <TextField source="Amount" />
          <TextField source="Wage" />
          <TextField source="Rrn" />
          <TextField source="SecurePan" />
          <TextField source="TRACENO" />
          <TextField source="RRN" />
          <TextField source="Status" />
          <TextField source="HashedCardNumber" />
          <TextField source="CID" />
          <TextField source="website" />
          <TextField source="StateCode" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </ShowView>
);

export const InvoiceEdit = (props) => (
  <EditView {...props}>
    <TextField source="objectId" />
    <ReferenceField link="show" label="کاربر" source="userId" reference="user">
      <TextField source="name" />
    </ReferenceField>
    <NumberField source="price" />
    <TextField source="sku" />
    <BooleanInput source="refundedToWallet" defaultValue={false} />
    <BooleanInput source="refundedToCash" defaultValue={false} />
    <BooleanField source="completed" />
    <TextField source="gatewayName" />
    <TextField source="statusName" />
    <TextField source="typeName" />
    <TextField source="market" />
  </EditView>
);
